import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../../app/localization/localization";
import { RootStoreContext } from "../../../app/stores/rootStore";

const PortareAvantiButton = () => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const {ZwibblerUseMoveFront, isPickEnabled} = rootStore.zwibblerStore
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const handleClick = () => {
    ZwibblerUseMoveFront();
  };

  return (
    <>
      <Button
        id="avanti"
        className={classNames(
          "w-100 px-1 pt-1 pb-1 toolbarButton transparentButton",
          `${theme!.toolbarIconColor}`
        )}
        color=""
        disabled={!isPickEnabled}
        onClick={() => handleClick()}
        style={{ position: "relative" }}
      >
        <i className="fas fa-bring-forward iconToolbarButton"></i>

        <h6 className="textToolbarButton mb-0">
          {t("toolbar_move_forward_button")}
        </h6>
      </Button>
    </>
  );
};

export default observer(PortareAvantiButton);
